// Small helper to lazy-load Razorpay Checkout script exactly once.
let razorpayPromise = null;

export function loadRazorpay() {
  if (typeof window === "undefined") return Promise.resolve(false);
  if (window.Razorpay) return Promise.resolve(true);
  if (razorpayPromise) return razorpayPromise;

  razorpayPromise = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => {
      razorpayPromise = null;
      resolve(false);
    };
    document.body.appendChild(s);
  });
  return razorpayPromise;
}
